// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 分页查询订单列表 GET /api/v1/orders */
export async function OrderControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOrderListItemDtoArray>(
    "/api/v1/orders",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 查询订单详情 GET /api/v1/orders/${param0} */
export async function OrderControllerGetByIdV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetByIdV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderDto>(`/api/v1/orders/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 查看背调信息 GET /api/v1/orders/${param0}/background-check */
export async function OrderControllerBackgroundCheckV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerBackgroundCheckV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputBackgroundCheckInfoDto>(
    `/api/v1/orders/${param0}/background-check`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询订单操作日志 GET /api/v1/orders/${param0}/operation-logs */
export async function OrderControllerListOperationLogsV1(
  params: MyApi.OrderControllerListOperationLogsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderOperationLogDtoArray>(
    `/api/v1/orders/${param0}/operation-logs`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询订单追踪记录列表 GET /api/v1/orders/${param0}/tracking-records */
export async function OrderControllerListTrackingRecordsV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerListTrackingRecordsV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputOrderTrackingRecordDtoArray>(
    `/api/v1/orders/${param0}/tracking-records`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 设置租金账单优惠金额 管理端财务对未结清租金类账单设置优惠；优惠金额须小于账单需要支付金额(amount)，且优惠后应付不得低于已付金额 POST /api/v1/orders/add-discount */
export async function OrderControllerAddDiscountV1(
  body: MyApi.AddDiscountDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentDto>(
    "/api/v1/orders/add-discount",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 设置以租代购结清后是否自动完成 仅以租代购订单。关闭后，用户主动支付与系统自动扣款结清最后一期都不会把订单标为已完成，需管理员手动完成。默认开启。 POST /api/v1/orders/auto-complete-on-bill-settled */
export async function OrderControllerUpdateAutoCompleteOnBillSettledV1(
  body: MyApi.UpdateOrderAutoCompleteOnBillSettledDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/auto-complete-on-bill-settled",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 资产绑定订单 POST /api/v1/orders/bind-asset */
export async function OrderControllerBindAssetV1(
  body: MyApi.BindAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputBindAssetDto>(
    "/api/v1/orders/bind-asset",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消订单 POST /api/v1/orders/cancel */
export async function OrderControllerCancelV1(
  body: MyApi.CancelOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCancelOrderDto>(
    "/api/v1/orders/cancel",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消所有代扣计划 POST /api/v1/orders/cancel-all-pxz-withhold-plans */
export async function OrderControllerCancelAllPxzWithholdPlansV1(
  body: MyApi.CancelAllPxzWithholdPlansDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/cancel-all-pxz-withhold-plans",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消信用免押 POST /api/v1/orders/cancel-credit-free */
export async function OrderControllerCancelCreditFreeV1(
  body: MyApi.CancelCreditFreeDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/cancel-credit-free",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 取消信用免押扣除支付 POST /api/v1/orders/cancel-credit-free-deduct */
export async function OrderControllerCancelCreditFreeDeductV1(
  body: MyApi.CancelCreditFreeDeductDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/cancel-credit-free-deduct",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 合同解约（取消剩余代扣并解除授权） POST /api/v1/orders/cancel-pxz-sign */
export async function OrderControllerCancelPxzSignV1(
  body: MyApi.CancelPxzSignDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/cancel-pxz-sign", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 取消单期代扣计划 POST /api/v1/orders/cancel-pxz-withhold-plan */
export async function OrderControllerCancelPxzWithholdPlanV1(
  body: MyApi.CancelPxzWithholdPlanDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/cancel-pxz-withhold-plan",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 完成订单 短租 / 日租 / 时租订单须先归还资产（status=returned）后才能完成；若仍有有效拍小租授权签约，将先解约（取消剩余代扣并解除授权），解约失败则阻断完成。可选 isUnfreeze：完成订单后同步退还已支付押金（paid）或解冻信用免押（frozen）。 POST /api/v1/orders/complete */
export async function OrderControllerCompleteV1(
  body: MyApi.CompleteOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/complete", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 完结免押订单 POST /api/v1/orders/complete-credit-free */
export async function OrderControllerCompleteCreditFreeV1(
  body: MyApi.CompleteCreditFreeDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/complete-credit-free",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取各 Tab 订单数量 统计待付款、待收货、租赁中、已逾期、已完成订单数量，规则与列表 tab 筛选一致，受门店管辖范围限制 GET /api/v1/orders/count */
export async function OrderControllerGetOrderCountV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputOrderCountDto>("/api/v1/orders/count", {
    method: "GET",
    ...(options || {}),
  });
}

/** 扣除押金 POST /api/v1/orders/deduct-deposit */
export async function OrderControllerDeductDepositV1(
  body: MyApi.DeductDepositDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputDeductDepositDto>(
    "/api/v1/orders/deduct-deposit",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 拍小租签约合同下载 GET /api/v1/orders/download-pxz-sign-contract */
export async function OrderControllerDownloadPxzSignContractV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerDownloadPxzSignContractV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseString>(
    "/api/v1/orders/download-pxz-sign-contract",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 下载E签宝合同 GET /api/v1/orders/esign-contract */
export async function OrderControllerDownloadEsignFileV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerDownloadEsignFileV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseEsignSignedFilesDownloadDataDto>(
    "/api/v1/orders/esign-contract",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** E签宝催签 POST /api/v1/orders/esign-remind */
export async function OrderControllerEsignRemindV1(
  body: MyApi.BaseQueryOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/esign-remind", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取E签宝签署链接 GET /api/v1/orders/esign-sign-url */
export async function OrderControllerGetEsignSignUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetEsignSignUrlV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseEsignSignUrlDataDto>(
    "/api/v1/orders/esign-sign-url",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 强制解绑 POST /api/v1/orders/force-unbind */
export async function OrderControllerForceUnbindV1(
  body: MyApi.ForceUnbindDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/force-unbind", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 短租续租 与 C 端一致：使用中或待归还均可提前续租，须最后一期分期/续租账单已支付；确认后立即延长租期并创建续租账单，用户可前往支付计划付款。 POST /api/v1/orders/installment-renewal */
export async function OrderControllerInstallmentRenewalV1(
  body: MyApi.AdminInstallmentRenewalDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRenewOrderDto>(
    "/api/v1/orders/installment-renewal",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取赋强公证公证书链接 GET /api/v1/orders/notary-cert-url */
export async function OrderControllerGetNotaryCertUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerGetNotaryCertUrlV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseString>("/api/v1/orders/notary-cert-url", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 押金线下入账 POST /api/v1/orders/offline-deposit-payment */
export async function OrderControllerOfflineDepositPaymentV1(
  body: MyApi.OfflineDepositPaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/offline-deposit-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 押金线下退款 POST /api/v1/orders/offline-deposit-refund */
export async function OrderControllerOfflineDepositRefundV1(
  body: MyApi.OfflineDepositRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/offline-deposit-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线下入账 POST /api/v1/orders/offline-payment */
export async function OrderControllerOfflinePaymentV1(
  body: MyApi.OfflinePaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/offline-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线下退款 POST /api/v1/orders/offline-refund */
export async function OrderControllerOfflineRefundV1(
  body: MyApi.OfflineRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/offline-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的账单退款 POST /api/v1/orders/online-bill-refund */
export async function OrderControllerOnlineBillRefundV1(
  body: MyApi.OnlineBillRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-bill-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的账单退款查询 GET /api/v1/orders/online-bill-refund-query */
export async function OrderControllerOnlineBillRefundQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlineBillRefundQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-bill-refund-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 用户线上支付的押金退款 POST /api/v1/orders/online-deposit-refund */
export async function OrderControllerOnlineDepositRefundV1(
  body: MyApi.OnlineDepositRefundDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-deposit-refund",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 线上支付的押金退款查询 GET /api/v1/orders/online-deposit-refund-query */
export async function OrderControllerOnlineDepositRefundQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlineDepositRefundQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRefundRecordDto>(
    "/api/v1/orders/online-deposit-refund-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 在线扣款 POST /api/v1/orders/online-payment */
export async function OrderControllerOnlinePaymentV1(
  body: MyApi.OnlinePaymentDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputPaymentRecordDto>(
    "/api/v1/orders/online-payment",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 在线扣款查询 GET /api/v1/orders/online-payment-query */
export async function OrderControllerOnlinePaymentQueryV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.OrderControllerOnlinePaymentQueryV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOnlinePaymentQueryDto>(
    "/api/v1/orders/online-payment-query",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 日租/时租续租 校验与出账逻辑同 C 端。后付：确认后立即延长租期并创建待支付续租账单。先付：须 confirmOfflinePaid=true，续租账单记为线下已支付并立即延长租期。须结清全部历史租金/续租账单；同一订单取消续租达 3 次后禁止再次续租；超期使用时续租时长须覆盖已超期区间。 POST /api/v1/orders/rental-renewal */
export async function OrderControllerRenewalV1(
  body: MyApi.AdminRentalRenewalDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputRenewOrderDto>(
    "/api/v1/orders/rental-renewal",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 归还资产 POST /api/v1/orders/return-asset */
export async function OrderControllerReturnAssetV1(
  body: MyApi.ReturnAssetDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>("/api/v1/orders/return-asset", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 同步E签宝签署流程状态 POST /api/v1/orders/sync-esign-flow-status */
export async function OrderControllerSyncEsignFlowStatusV1(
  body: MyApi.SyncEsignFlowStatusDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputSyncEsignFlowStatusDto>(
    "/api/v1/orders/sync-esign-flow-status",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 手动同步赋强公证结果 POST /api/v1/orders/sync-notary-result */
export async function OrderControllerSyncNotaryResultV1(
  body: MyApi.BaseQueryOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseNotaryInfoDto>(
    "/api/v1/orders/sync-notary-result",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 同步拍小租签约状态 POST /api/v1/orders/sync-pxz-sign-status */
export async function OrderControllerSyncPxzSignStatusV1(
  body: MyApi.SyncPxzSignStatusDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/sync-pxz-sign-status",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 同步代扣规则 POST /api/v1/orders/sync-pxz-withhold-rules */
export async function OrderControllerSyncPxzWithholdRulesV1(
  body: MyApi.SyncPxzWithholdRulesDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/sync-pxz-withhold-rules",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 创建订单追踪记录 POST /api/v1/orders/tracking-records */
export async function OrderControllerCreateTrackingRecordV1(
  body: MyApi.CreateOrderTrackingRecordDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputOrderTrackingRecordDto>(
    "/api/v1/orders/tracking-records",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 修改订单押金金额 POST /api/v1/orders/update-deposit */
export async function OrderControllerUpdateDepositV1(
  body: MyApi.UpdateDepositDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUpdateDepositDto>(
    "/api/v1/orders/update-deposit",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 商家上传凭证 POST /api/v1/orders/upload-attachments */
export async function OrderControllerUploadAttachmentsV1(
  body: MyApi.UploadAttachmentsDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseBoolean>(
    "/api/v1/orders/upload-attachments",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
